import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.product-slider' ).length ) {
        $( '.product-slider__slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.product-slider' ).each( function( index, element ) {
          const productSlider = new Splide( element, {
            gap: '2rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            type: 'loop',
            speed: 800,
            arrows: true,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
                gap: '1rem',
              },
            },
          } );
          productSlider.on( 'overflow', function( isOverflow ) {
            if ( isOverflow ) {
              // Enough slides
            } else {
              productSlider.options = {
                drag: isOverflow,
              };
            }
          } );
          productSlider.mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'product-slider', COMPONENT );
} )( app );
